import type { PromptId } from '@risksmart-app/shared/ai/PromptId';

import { useAIWorkflowService } from '@/components/ai-workflows/useAIWorkflowService';

interface TextInferenceResult {
  generatedContent: string;
}

export const useTextInference = () => {
  const { runWorkflow } = useAIWorkflowService<TextInferenceResult>(
    'ai-engine/workflow-api/workflows/text-inference',
    'Text Inference'
  );

  const invokeTextInference = async (
    promptId: PromptId,
    bodyText: string
  ): Promise<string> => {
    const jobResult = await runWorkflow(() => ({
      promptId,
      bodyText,
    }));

    if (!jobResult.result?.generatedContent) {
      throw new Error('Text inference workflow returned no content');
    }

    return jobResult.result.generatedContent;
  };

  return { invokeTextInference };
};
